export default __webpack_public_path__ + "static/media/banner_market.9e514891.jpg";